import { render, staticRenderFns } from "./ColumnChartVT.vue?vue&type=template&id=6e01f56b&scoped=true"
import script from "./ColumnChartVT.vue?vue&type=script&lang=js"
export * from "./ColumnChartVT.vue?vue&type=script&lang=js"
import style0 from "./ColumnChartVT.vue?vue&type=style&index=0&id=6e01f56b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e01f56b",
  null
  
)

export default component.exports